import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { ImgV2 as Img } from '@alfa-bank/site-img-v2';
import { MagnifierMIcon } from '@alfalab/icons-glyph/MagnifierMIcon';
import { AddMIcon } from '@alfalab/icons-glyph/AddMIcon';

import type { IYandexSearchInputDesktopDeps, TYandexSearchInputDesktop } from '../models';
import { YandexSearchInput as Component } from '../index';

import styles from './desktop.css';

export const YandexSearchInputDesktop = createWidget<
    IYandexSearchInputDesktopDeps,
    TYandexSearchInputDesktop
>({
    styles,
    Img,
    Button,
    MagnifierMIcon,
    AddMIcon,
})(Component);
